export const addFileUseCase = async ({
  getFreshToken,
  getEndpointUrl,
  filePath,
  content,
}) => {
  try {
    const freshToken = await getFreshToken();
    const response = await fetch(getEndpointUrl() + "/addFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${freshToken}`,
      },
      body: JSON.stringify({ filePath, content }),
    });

    if (!response.ok) throw new Error("Error adding the new file.");

    console.log("File added successfully.");
    return response;
  } catch (error) {
    console.error("Error adding file:", error);
    throw error;
  }
};
